import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '../views/Login.vue'
import RestablecerPassword from '../views/RestablecerPassword.vue'
import CambiarPassword from '../views/CambiarPassword.vue'
import Logout from '../views/Logout.vue'
import Inscripcion from '../views/Inscripcion.vue'

import AreaSocios from '../views/AreaSocios.vue'
import SociosFamilia from '../views/SociosFamilia.vue'
import SociosModificarDatos from '../views/SociosModificarDatos.vue'
import SociosRenovar from '../views/SociosRenovar.vue'
import SociosPersonaEditar from '../views/SociosPersonaEditar.vue'
import SociosEditarActividades from '../views/SociosEditarActividades.vue'
import SociosBalance from '../views/SociosBalance.vue'
import SociosHorarioExtraescolares from '../views/SociosHorarioExtraescolares.vue'
import SociosNormativaExtraescolares from '../views/SociosNormativaExtraescolares.vue'
import SociosContacto from '../views/SociosContacto.vue'
import SociosInfoPrimeros from '../views/SociosInfoPrimeros.vue'

import AreaAdmin from '../views/AreaAdmin.vue'
import AdminFamilias from '../views/AdminFamilias.vue'
import AdminActividades from '../views/AdminActividades.vue'
import AdminActividad from '../views/AdminActividad.vue'
import AdminNiveles from '../views/AdminNiveles.vue'
import AdminCambioNiveles from '../views/AdminCambioNiveles.vue'
import AdminTesoreria from '../views/AdminTesoreria.vue'
import AdminNuevoApunte from '../views/AdminNuevoApunte.vue'
import AdminApunteDetalle from '../views/AdminApunteDetalle.vue'
import AdminSaldos from '../views/AdminSaldos.vue'
import AdminListadosClases from '../views/AdminListadosClases.vue'
import AdminEditarParticipaciones from '../views/AdminEditarParticipaciones.vue'

import AreaExterna from '../views/AreaExterna.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '',
		component: AreaSocios,
		children: [
			{
				path: '',
				component: SociosFamilia,
				props: {
					admin: false,
				}
			},
			{
				path: 'editar',
				component: SociosModificarDatos,
			},
			{
				path: 'renovar',
				component: SociosRenovar,
				props: {
					admin: false,
				}
			},
			{
				path: 'persona/:id_persona/editar',
				component: SociosPersonaEditar,
				props: route => ({
					admin: false,
					crear: null,
					id_familia: null,
					id_persona: route.params.id_persona,
				})
			},
			{
				path: 'persona/nuevo/adulto',
				component: SociosPersonaEditar,
				props: {
					admin: false,
					crear: 'adulto',
					id_familia: null,
					id_persona: null,
				},
			},
			{
				path: 'persona/nuevo/menor',
				component: SociosPersonaEditar,
				props: {
					admin: false,
					crear: 'menor',
					id_familia: null,
					id_persona: null,
				},
			},
			{
				path: 'actividades/:id_persona/editar',
				component: SociosEditarActividades,
				props: route => ({
					admin: false,
					id_persona: route.params.id_persona
				})
			},
			{
				path: 'cuentas',
				component: SociosBalance,
				props: {
					admin: false,
					id_familia: null,
				}
			},
			{
				path: 'extraescolares/horario',
				component: SociosHorarioExtraescolares,
			},
			{
				path: 'extraescolares/normativa',
				component: SociosNormativaExtraescolares,
			},
			{
				path: 'extraescolares/primeros',
				component: SociosInfoPrimeros,
			},
			{
				path: 'contacto',
				component: SociosContacto,
			},
		]
	},
	{
		path: '/acceso',
		component: Login,
	},
	{
		path: '/acceso/restablecer',
		component: RestablecerPassword,
	},
	{
		path: '/acceso/cambiar/:token',
		component: CambiarPassword,
		props: true,
	},
	{
		path: '/acceso/salir',
		component: Logout,
	},
	{
		path: '/inscripcion',
		component: Inscripcion,
	},
	{
		path: '/admin',
		component: AreaAdmin,
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		//component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
		children: [
			{
				path: 'familias',
				component: AdminFamilias,
			},
			{
				path: 'familia/:id_familia',
				component: SociosFamilia,
				props: route => ({
					admin: true,
					id_familia: route.params.id_familia,
				})
			},
			{
				path: 'familia/:id_familia/editar',
				component: SociosModificarDatos,
				props: route => ({
					admin: true,
					id_familia: route.params.id_familia,
				})
			},
			{
				path: 'familia/:id_familia/renovar',
				component: SociosRenovar,
				props: route => ({
					admin: true,
					id_familia: route.params.id_familia,
				})
			},
			{
				path: 'familia/:id_familia/balance',
				component: SociosBalance,
				props: route => ({
					admin: true,
					id_familia: route.params.id_familia,
				})
			},
			{
				path: 'familia/:id_familia/apunte/nuevo',
				component: AdminNuevoApunte,
				props: true,
			},
			{
				path: 'familia/:id_familia/apunte/:id_apunte',
				component: AdminApunteDetalle,
				props: true,
			},
			{
				path: 'persona/:id_persona/editar',
				component: SociosPersonaEditar,
				props: route => ({
					admin: true,
					crear: null,
					id_familia: null,
					id_persona: route.params.id_persona,
				})
			},
			{
				path: 'familia/:id_familia/nuevo/adulto',
				component: SociosPersonaEditar,
				props: route => ({
					admin: true,
					crear: 'adulto',
					id_familia: route.params.id_familia,
					id_persona: null,
				})
			},
			{
				path: 'familia/:id_familia/nuevo/menor',
				component: SociosPersonaEditar,
				props: route => ({
					admin: true,
					crear: 'menor',
					id_familia: route.params.id_familia,
					id_persona: null,
				})
			},
			{
				path: 'persona/:id_persona/actividades',
				component: SociosEditarActividades,
				props: route => ({
					admin: true,
					id_persona: route.params.id_persona,
				})
			},
			{
				path: 'persona/:id_persona/actividades/avanzado',
				component: AdminEditarParticipaciones,
				props: route => ({
					id_persona: route.params.id_persona,
				})
			},
			{
				path: 'actividades',
				component: AdminActividades,
			},
			{
				path: 'actividad/:idActividad/:idPeriodo?',
				component: AdminActividad,
				props: route => ({
					externo: false,
					token: null,
					idActividad: route.params.idActividad,
					idPeriodo: route.params.idPeriodo,
				})
			},
			{
				path: 'niveles',
				component: AdminNiveles,
			},
			{
				path: 'niveles/clases1/:id_periodo?',
				component: AdminListadosClases,
				props: route => ({
					modelo: 1,
					id_periodo: route.params.id_periodo,
				})
			},
			{
				path: 'niveles/clases2/:id_periodo?',
				component: AdminListadosClases,
				props: route => ({
					modelo: 2,
					id_periodo: route.params.id_periodo,
				})
			},
			{
				path: 'niveles/cambio',
				component: AdminCambioNiveles,
			},
			{
				path: 'tesoreria',
				component: AdminTesoreria,
			},
			{
				path: 'tesoreria/saldos',
				component: AdminSaldos,
			},
		]
	},
	{
		path: '/externo',
		component: AreaExterna,
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		//component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
		children: [
			{
				path: 'extraescolares',
				component: SociosHorarioExtraescolares,
			},
			{
				path: 'extraescolares/primeros',
				component: SociosInfoPrimeros,
			},
			{
				path: 'actividad/:token/:idActividad/:idPeriodo?',
				component: AdminActividad,
				props: route => ({
					externo: true,
					token: route.params.token,
					idActividad: route.params.idActividad,
					idPeriodo: route.params.idPeriodo,
				})
			},
		]
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
